// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import workOrderStatusControl from '../../../utils/workOrderStatusControl';

const isDeactivatedStatus = (status) => String(status || '').toLowerCase() === 'deactivated';

const toggleCheckbox = (workOrder, selected, select) => {
  if (workOrder.status === 'completed') ;
  const id = workOrder._id;
  if (selected.includes(id)) {
    return select(selected.filter((el) => el !== id));
  }
  return select([...selected, id]);
};

const ControlsButton = ({
  workOrder,
  activeTab,
  setCurrentWorkOrder,
  selectedWorkOrders,
  selectWorkOrder,
  toggleModal,
  history,
  match,
  acceptInvite,
  confirmWorkOrder,
  profile,
}) => {
  const workOrderControlByStatus = workOrder ? workOrderStatusControl(workOrder.status) : {};
  const isSuspended = Boolean(profile?.suspended);
  const isDeactivated = isDeactivatedStatus(profile?.status);
  // Suspended and deactivated contractors keep full read access but cannot
  // apply, counter-offer or accept routed work orders.
  const restricted = isSuspended || isDeactivated;
  const restrictedTitle = isDeactivated
    ? 'Your account is deactivated — you can view work only.'
    : 'Your account is suspended — you cannot apply to or accept work.';
  return (
    <>
      {/* {(!workOrderControlByStatus.beforeAssigned || activeTab === 'routed')
        && !workOrderControlByStatus.canceled ? (
          <label className="check_btn">
            <input
              type="checkbox"
              id={`${workOrder.status}Checkbox${workOrder._id}`}
              checked={selectedWorkOrders.includes(workOrder._id)}
              onChange={() => {
                toggleCheckbox(workOrder, selectedWorkOrders, selectWorkOrder);
              }}
            />
          </label>
        ) : null} */}

      {activeTab === 'routed' ? (
        <button
          type="button"
          className={`wo-btn wo-btn--confirm${restricted ? ' wo-btn--disabled' : ''}`}
          disabled={restricted}
          title={restricted ? restrictedTitle : undefined}
          onClick={(event) => {
            event.preventDefault();
            if (restricted) return;
            acceptInvite({ workOrdersId: [workOrder._id] });
          }}
        >
          Accept Assignment
        </button>
      ) : null}

      {activeTab === 'routed' ? (
        <button
          type="button"
          className={`wo-btn wo-btn--details ${workOrder.applied ? 'success' : ''}${restricted ? ' wo-btn--disabled' : ''}`}
          disabled={restricted}
          title={restricted ? restrictedTitle : undefined}
          onClick={() => {
            if (restricted) return;
            setCurrentWorkOrder(workOrder);
            toggleModal(true, 'applyModal', false, { openCounterOffer: true });
          }}
        >
          {workOrder.applied ? 'Edit Counter Offer' : 'Counter Offer'}
        </button>
      ) : null}

      {(activeTab === 'available' || activeTab === 'applied') ? (
        <button
          type="button"
          className={`wo-btn wo-btn--details${restricted ? ' wo-btn--disabled' : ''}`}
          disabled={restricted}
          title={restricted ? restrictedTitle : undefined}
          onClick={() => {
            if (restricted) return;
            setCurrentWorkOrder(workOrder);
            toggleModal(true, 'applyModal');
          }}
        >
          Apply / Counter
        </button>
      ) : null}

      <button
        type="button"
        className="wo-btn wo-btn--view"
        onClick={() => {
          setCurrentWorkOrder(workOrder);
          toggleModal(true, 'viewDetailsWorkOrderModal', true, { id: workOrder._id });
          const { tab } = match.params;
          const pathname = tab ? `/dashboard/${tab}` : '/dashboard';
          history.replace({
            pathname,
            search: `?type=work-order&id=${workOrder._id}`,
          });
        }}
      >
        View
      </button>

      {workOrderControlByStatus.assigned ? (
        workOrder.confirmed ? (
          <button type="button" className="wo-btn wo-btn--confirm" disabled>
            Confirmed
          </button>
        ) : (
          <button
            type="button"
            className="wo-btn wo-btn--confirm"
            onClick={() => {
              confirmWorkOrder([workOrder._id]);
            }}
          >
            Confirm
          </button>
        )
      ) : null}
    </>
  );
};

const mapStateToProps = (state) => ({
  profile: state.profile,
});

export default connect(mapStateToProps)(withRouter(ControlsButton));
